import QRCode from "qrcode";

const object2Array = object => {
  let result = [];

  for (var key in object) {
    result.push({
      id: key,
      name: object[key]
    });
  }

  return result;
};

const formDataConvert = (data, slug) => {
  let validate_slug = true;
  let formData = new FormData();

  for (var key in data) {
    if (slug == "vet") validate_slug = key !== "vet";

    if (slug == "owner") validate_slug = key !== "vet" && key !== "owner";

    if (key !== "id" && validate_slug) {
      if (data[key]) {
        formData.append(`${key}`, data[key]);
      }
    }
  }
  return formData;
};

const header = {
  "Content-Type": "application/json",
  "Accept-Language": "es-es",
  Accept: "*/*"
};

const headerAuth = token => {
  return {
    "Content-Type": "application/json",
    "Accept-Language": "es-es",
    Accept: "*/*",
    Authorization: `JWT ${token}`
  };
};

const headerAuthFile = token => {
  return {
    "Content-Type": "multipart/form-data",
    "Accept-Language": "es-es",
    Accept: "*/*",
    Authorization: `JWT ${token}`
  };
};

const downloadFiles = (data, name_file) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name_file);
  document.body.appendChild(link);
  link.click();
};

const validateImages = img => {
  if (!img) return "https://mpi.sfo3.digitaloceanspaces.com/no_image.jpeg"; //`${process.env.VUE_APP_URL_API}${img}`;

  if (img.startsWith("https://")) {
    return img;
  } else if (img.startsWith("http://")) {
    return img.replace("http://", "https://");
  } else {
    return `${process.env.VUE_APP_URL_API}${img}`;
  }
};

const generateQRInventory = async data => {
  let url = `${process.env.VUE_APP_ACTUAL_URL}/search_pet/${data}`;
  let qr = await QRCode.toDataURL(url);
  return qr;
};

export default {
  header,
  headerAuth,
  object2Array,
  downloadFiles,
  headerAuthFile,
  validateImages,
  formDataConvert,
  generateQRInventory
};
